import Vue from "vue"
import Vuex from "vuex"

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    loggedIn: false,
    storageURL:
      window.location.hostname.includes("localhost") || window.location.hostname.includes("dev")
        ? "https://dev.api.theindexproject.org/storage/"
        : "https://api.theindexproject.org/storage/",
    apiURL:
      window.location.hostname.includes("localhost") || window.location.hostname.includes("dev")
        ? "https://dev.api.theindexproject.org/api/"
        : "https://api.theindexproject.org/api/",
    menuVisible: false,
    headerVisible: true,
    footerVisible: true,
    menuCube: {
      rX: 55,
      rZ: 0,
      isRotating: true,
      transition: "transform 400ms linear",
    },
    presets: {},
    filters: {},
    defaultFilters: {
      month: [],
      category: [],
      goal: [],
      continent: [],
      year: [],
      region: [],
      country: [],
      keyword: [],
      keywordName: [],
      search: [],
      mode: {
        category: "or",
        goal: "or",
        country: "or",
        year: "or",
        continent: "or",
        region: "or",
        keyword: "or",
        month: "or",
        search: "and",
      },
      enabled: ["category", "goal", "continent", "year", "country", "keyword"],
      extra: [],
    },
    settings: {
      showTooltips: true,
    },
  },
  actions: {
    // Stops menu cube rotation
    haltRotation() {
      this.state.menuCube.transition = "transform 400ms ease"
      this.state.menuCube.rX = 0
      this.state.menuCube.isRotating = false
      this.state.menuCube.rZ += 90 - (this.state.menuCube.rZ % 90)
    },
    // Resumes menu cube rotation
    resumeRotation() {
      if (!this.state.menuVisible) {
        setTimeout(() => {
          this.state.menuCube.transition = "transform 400ms linear"
        }, 400)
        this.state.menuCube.rX = 55
        this.state.menuCube.isRotating = true
      }
    },
    // stores settings in IDB
    storeSettings() {
      this._vm.$idbSet("settings", this.state.settings).then(() => {
        console.log("settings saved.")
      })
    },
    // saves a preset in the API
    savePreset(state, { filters, name }) {
      this._vm.$http.post(this.state.apiURL + "bp/createfilter", { filters, name }).then(
        response => {
          console.log(response)
          this.state.presets[name].id = response.body.filter.id
        },
        error => {
          console.log(error)
        }
      )
    },
    // deletes a preset in the API
    deletePreset(state, { presetId }) {
      this._vm.$http.get(this.state.apiURL + "bp/destroyfilter/" + presetId).then(
        response => {
          console.log(response)
        },
        error => {
          console.log(error)
        }
      )
    },
    // parses presets from JSON format, deletes/renames properties
    parsePresets(state, { presets }) {
      // clears out presets just in case
      this.state.presets = {}

      // TODO extra filters
      let arrayFilters = [
        "month",
        "category",
        "goal",
        "continent",
        "year",
        "region",
        "country",
        "keyword",
        "keywordName",
        "search",
        "extra",
        "meta_enabled",
      ]
      let deleteParameters = ["user_id", "name", "created_at", "updated_at", "meta_enabled"]
      // For each preset
      for (let preset of presets) {
        // Parses strings into arrays
        for (let arrayFilter of arrayFilters) {
          preset[arrayFilter] = JSON.parse(preset[arrayFilter])
          if (preset[arrayFilter] == null) preset[arrayFilter] = []
        }
        // Moves modes into a single object
        preset.mode = {}
        for (let mode of Object.keys(this.state.defaultFilters.mode)) {
          preset.mode[mode] = preset["mode_" + mode]
          delete preset["mode_" + mode]
        }
        // Moves meta_enabled to enabled
        preset.enabled = preset.meta_enabled
        // Get the name for saving locally
        let presetName = preset["name"]
        // Deletes unnecessary parameters
        for (let deleteParameter of deleteParameters) {
          delete preset[deleteParameter]
        }
        // Load preset locally
        this.state.presets[presetName] = preset
      }
    },
    //* --------------------------------------- AUTH ---------------------------------------
    // registers a new user
    register(state, { user }) {
      return new Promise((resolve, reject) => {
        this._vm.$http.post(this.state.apiURL + "bp/register", user).then(
          response => {
            this._vm.$cookies.set("token", response.body.token)
            this.state.loggedIn = true
            resolve(response)
          },
          error => {
            reject(error)
          }
        )
      })
    },
    // logs user in, sets the token in a cookie
    // expected parameter - user: {email: "user@email.com", password: "password"}
    login(state, { user }) {
      return new Promise((resolve, reject) => {
        this._vm.$http.post(this.state.apiURL + "login", user).then(
          r => {
            // Check if has role BP
            if (r.body.user.main_role.name == "bigpicture" || r.body.user.roles.find(role => role.name == "bigpicture")) {
              this._vm.$cookies.set("token", r.body.token)
              this.state.loggedIn = true
              resolve(r)
            } else {
              reject(["User unauthorized."])
            }
          },
          error => {
            reject(["Failed to log in. Please check your credentials."])
          }
        )
      })
    },
    // gets user info based on token
    // TODO use HTTPonly cookie
    user() {
      return new Promise((resolve, reject) => {
        this._vm.$http.get(this.state.apiURL + "user").then(
          r => {
            // Check if has role BP
            if (r.body.user.main_role.name == "bigpicture" || r.body.user.roles.find(role => role.name == "bigpicture")) {
              this.dispatch("parsePresets", { presets: r.body.user.filters })
              this.state.loggedIn = true
              resolve(r)
            } else {
              reject(r)
            }
          },
          error => {
            console.log(error)
            reject(error)
          }
        )
      })
    },
    // logs the user out
    logout() {
      this._vm.$cookies.remove("token")
      this._vm.$cookies.remove("designsStored")
      this._vm.$idbClear()
      this.state.loggedIn = false
    },
    // sends a forgot password email
    forgotPassword(state, { email }) {
      return new Promise((resolve, reject) => {
        this._vm.$http.post(this.state.apiURL + "reset-password-mail", { email }).then(
          response => {
            resolve(response)
          },
          error => {
            reject(error)
          }
        )
      })
    },
  },
})
